<template>
  <AppShell :nav-items="navItems">
    <template #drawer-append>
      <div v-if="workspace && workspace.member" class="p2p-drawer-status">
        <router-link v-if="workspace.pending_approvals" to="/approvals" class="p2p-drawer-alert">
          <span class="p2p-dot warn"></span>{{ workspace.pending_approvals }} waiting for approval
        </router-link>
        <router-link v-if="workspace.needs_attention" to="/posts?tab=attention" class="p2p-drawer-alert">
          <span class="p2p-dot bad"></span>{{ workspace.needs_attention }} need attention
        </router-link>
        <div class="p2p-drawer-credits">
          <span class="p2p-mono">{{ credits }}</span> credits
        </div>
      </div>
    </template>
    <template #before-page>
      <div v-if="incident" class="p2p-incident" role="status">
        <v-icon small color="#fbbf24">mdi-alert-outline</v-icon>
        <span>{{ incident }}</span>
      </div>
    </template>
  </AppShell>
</template>

<script>
import AppShell from '@shared/components/AppShell.vue';
import { get } from './api';

const STATUS_EVERY_MS = 3 * 60 * 1000;

export default {
  name: 'PublisherApp',
  components: { AppShell },
  data: () => ({ incident: '', statusAt: 0, statusTimer: null }),
  computed: {
    workspace() { return this.$store.getters['publisher/workspace']; },
    credits() {
      const value = this.workspace ? Number(this.workspace.available_credits) : 0;
      return Number.isFinite(value) ? Math.floor(value) : 0;
    },
    navItems() {
      const items = [
        { title: 'Create', icon: 'mdi-plus-box-outline', to: '/create' },
        { title: 'Projects', icon: 'mdi-view-grid-outline', to: '/' },
        { title: 'Approvals', icon: 'mdi-check-decagram-outline', to: '/approvals' },
        { title: 'Posts', icon: 'mdi-calendar-text-outline', to: '/posts' },
        { title: 'Connections', icon: 'mdi-link-variant', to: '/connections' },
        { title: 'Plans', icon: 'mdi-credit-card-outline', to: '/pricing' },
        { title: 'Settings', icon: 'mdi-cog-outline', to: '/settings' },
        { title: 'Help', icon: 'mdi-help-circle-outline', to: '/help' }
      ];
      if (this.$store.getters.isAdmin) {
        items.push({ title: 'Publishing controls', icon: 'mdi-tune-variant', to: '/admin/publishing' });
        items.push({ title: 'Support', icon: 'mdi-lifebuoy', to: '/admin/support' });
        items.push({ title: 'Quality review', icon: 'mdi-star-check-outline', to: '/admin/quality' });
      }
      return items;
    }
  },
  mounted() {
    window.addEventListener('focus', this.refresh);
    this.refresh();
    this.statusTimer = window.setInterval(() => this.loadStatus(true), STATUS_EVERY_MS);
  },
  beforeDestroy() {
    window.removeEventListener('focus', this.refresh);
    window.clearInterval(this.statusTimer);
  },
  methods: {
    async refresh() {
      // The banner needs to know who is signed in, so the workspace loads first.
      if (this.$store.getters.isAuthenticated) await this.$store.dispatch('publisher/loadWorkspace').catch(() => {});
      this.loadStatus(false);
    },
    // A provider incident or a maintenance pause shows on every page until it clears.
    async loadStatus(force) {
      if (!force && Date.now() - this.statusAt < 30000) return;
      this.statusAt = Date.now();
      try {
        const status = await get('/status');
        this.incident = (await this.concerned(status.incident_networks || [])) ? (status.incident || '') : '';
      } catch (error) { /* Keep the last known state. */ }
    },
    // A network-only incident is for members who post there; site-wide ones are for everyone.
    async concerned(keys) {
      if (!keys.length) return true;
      if (!this.workspace || !this.workspace.member) return false;
      try {
        if (!this.$store.getters['publisher/connected'].length) await this.$store.dispatch('publisher/loadAccounts');
      } catch (error) {
        return false;
      }
      return this.$store.getters['publisher/connected'].some(account => keys.indexOf(account.platform) >= 0);
    }
  },
  watch: {
    $route() { this.refresh(); }
  }
};
</script>

<style>
.p2p-incident{display:flex;align-items:flex-start;gap:10px;margin:12px 16px 0;padding:10px 14px;border-radius:12px;
  border:1px solid rgba(251,191,36,.3);background:rgba(251,191,36,.08);color:var(--p2p-warn-text);font-size:14px;line-height:1.45}
</style>
